export type TestimonialItem = {
  id: string;
  customerName: string;
  designation: string;
  company: string;
  testimonial: string;
  rating: number;
  avatarUrl: string | null;
  altText: string | null;
  isDemo: boolean;
};

export function initialFor(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "?";
  return trimmed.charAt(0).toUpperCase();
}

export function isValidHttpsUrl(v: string | null | undefined): v is string {
  if (!v) return false;
  // Site-relative paths (Media Library assets, bundled CDN images) are valid.
  if (v.startsWith("/") && !v.startsWith("//")) return true;
  try {
    return new URL(v).protocol === "https:";
  } catch {
    return false;
  }
}

export const TESTIMONIAL_FALLBACKS: TestimonialItem[] = [
  {
    id: "fallback-amit",
    customerName: "Amit Sharma",
    designation: "Product Manager",
    company: "",
    testimonial:
      "[DEMO] The variety across the week is what surprised me most — no two lunches felt repeated, and portions were spot-on for a busy workday.",
    rating: 5,
    avatarUrl: null,
    altText: null,
    isDemo: true,
  },
  {
    id: "fallback-priya",
    customerName: "Priya Mehta",
    designation: "Yoga Instructor",
    company: "",
    testimonial:
      "[DEMO] Fresh, thoughtful and never heavy. The breakfast bowls have made mornings so much easier for me.",
    rating: 5,
    avatarUrl: null,
    altText: null,
    isDemo: true,
  },
  {
    id: "fallback-rahul",
    customerName: "Rahul Desai",
    designation: "Software Engineer",
    company: "",
    testimonial:
      "[DEMO] Deliveries arrive on time and packaging feels genuinely food-safe. Small details, but they add up.",
    rating: 5,
    avatarUrl: null,
    altText: null,
    isDemo: true,
  },
  {
    id: "fallback-neha",
    customerName: "Neha Kapoor",
    designation: "Marketing Lead",
    company: "",
    testimonial:
      "[DEMO] I appreciate how balanced the meals are — enough protein, the right amount of grains, and always some greens.",
    rating: 5,
    avatarUrl: null,
    altText: null,
    isDemo: true,
  },
  {
    id: "fallback-sneha",
    customerName: "Sneha Joshi",
    designation: "Nutritionist",
    company: "",
    testimonial:
      "[DEMO] As a nutritionist I'm picky about ingredients. The farm-direct sourcing shows — the produce actually tastes seasonal.",
    rating: 5,
    avatarUrl: null,
    altText: null,
    isDemo: true,
  },
  {
    id: "fallback-vikram",
    customerName: "Vikram Shah",
    designation: "Chartered Accountant",
    company: "",
    testimonial:
      "[DEMO] Dinners are light and easy on digestion, which is exactly what I wanted after long days at the office.",
    rating: 5,
    avatarUrl: null,
    altText: null,
    isDemo: true,
  },
];